module.exports = __webpack_public_path__ + "static/media/odejmowanie_w_zakresie_20_rozpisywanie.a4add995.pdf";